import React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { RotateIcon } from '@rbilabs/components-library/build/components/rotate-icon';
import styled from 'styled-components';

import { IDimensions, IOrientation, ISize } from './types';

const defaultMobileDimensions: IDimensions = {
  width: 8,
  height: 14,
};
const defaultDesktopDimensions: IDimensions = {
  width: 12,
  height: 21,
};
export const defaultSize: ISize = {
  mobile: defaultMobileDimensions,
  desktop: defaultDesktopDimensions,
};

export const defaultOrientation: IOrientation = {
  initialAngleDeg: 0,
  finalAngleDeg: 90,
};

const maxDimension = (dimension: IDimensions) => Math.max(dimension.height, dimension.width);

interface IArrowContainer {
  size: ISize;
  open: boolean;
}
const ArrowContainer = styled.div<IArrowContainer>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 1;

  height: ${p => maxDimension(p.size.mobile)}px;
  width: ${p => maxDimension(p.size.mobile)}px;

  ${Styles.desktop} {
    height: ${(p: IArrowContainer) => `${maxDimension(p.size.desktop)}px`};
    width: ${(p: IArrowContainer) => `${maxDimension(p.size.desktop)}px`};
  }
`;

interface IDropdownArrow {
  open: boolean;
  disabled: boolean;
  size: ISize;
  orientation: IOrientation;
}

export const DropdownArrow: React.FC<IDropdownArrow> = ({ open, disabled, orientation, size }) => {
  return (
    <ArrowContainer size={size} open={open}>
      <RotateIcon
        active={open}
        fromDeg={orientation.initialAngleDeg}
        toDeg={orientation.finalAngleDeg}
      >
        <Icon icon="next" color={disabled ? 'icon-disabled' : 'icon-default'} aria-hidden />
      </RotateIcon>
    </ArrowContainer>
  );
};
